






















































import { Component, Prop, Vue } from 'vue-property-decorator';
import DataGrid from '@/components/reusable/datagrid/DataGrid.vue';
import IDataGrid from '@/components/reusable/datagrid/IDataGrid';
import DataGridOptions from '@/components/reusable/datagrid/DataGridOptions';

import UserEdit from '@/components/administration/Users/UserEdit.vue';

interface ISearchTerms {
    Name: string;
    Active: boolean;
    IsAdmin: boolean;
}

@Component({
    components: {
        DataGrid,
        UserEdit
    }
})
export default class UsersList extends Vue {
    private GridOptions: DataGridOptions;
    private SearchTerms: ISearchTerms ;
    private SelectedId: number = 0;

    constructor() {
        super();

        this.GridOptions = new DataGridOptions();
        this.GridOptions.MethodEndpoint = this.$store.state.basePath + this.$store.state.endpoints.userGetList;
        this.GridOptions.DeleteMethodEndpoint = this.$store.state.basePath + this.$store.state.endpoints.userDelete;
        this.GridOptions.HasDelete = true;
        this.SearchTerms = { Name: '', Active: true, IsAdmin: true };
        this.GridOptions.VirtualScrolling = false;
        this.GridOptions.Styles.Table = ['gridcontainer'];
        this.GridOptions.Styles.Header = ['gridheader'];
        this.GridOptions.Styles.Cell = ['gridcell'];
        this.GridOptions.Columns = [
            { Title: 'Id', FieldName: 'Id', Visible: false },
            { Title: 'First Name', FieldName: 'FirstName', Visible: true },
            { Title: 'LastName', FieldName: 'LastName', Visible: true },
            { Title: 'User Name', FieldName: 'UserName', Visible: true },
            { Title: 'Email', FieldName: 'Email', Visible: true }
        ];
    }

    private Search() {
        (this.$refs.dataGrid as unknown as IDataGrid).Search(this.SearchTerms);
    }

    private Clear() {
        this.SearchTerms.Name = '';
        this.SearchTerms.Active = true;

        (this.$refs.dataGrid as unknown as IDataGrid).Reload(true);
    }

    private Refresh() {
        (this.$refs.dataGrid as unknown as IDataGrid).Reload(true);
    }

    private ShowEditForm(id: number) {
        this.SelectedId = id;
        this.$bvModal.show('modal-edit');
    }

    private CloseEditForm() {
        this.$bvModal.hide('modal-edit');
    }

    private OnChangesSaved() {
        this.$bvToast.toast('Changes were saved successfully.',
            {
                variant: 'warning',
                noCloseButton: true,
                solid: true,
                autoHideDelay: 5000
            });

        this.Refresh();
    }
    private OnDeleteFinished() {
        this.$bvToast.toast('Company deleted successfully.',
            {
                variant: 'success',
                noCloseButton: true,
                solid: true,
                autoHideDelay: 5000
            });
    }
}
